const CURRENCY_SYMBOL: Record<string, string> = { RUB: '₽', USD: '$', EUR: '€' };

export function toNumber(value: number | string | null | undefined) {
  if (value === null || value === undefined) return null;
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function amountText(value: number | string | null | undefined, currency = 'RUB') {
  const parsed = toNumber(value) ?? 0;
  return `${Math.abs(parsed).toLocaleString('ru')} ${CURRENCY_SYMBOL[currency] ?? currency}`;
}

export function signedAmountText(value: number | string | null | undefined, currency = 'RUB') {
  const parsed = toNumber(value) ?? 0;
  const sign = parsed < 0 ? '-' : parsed > 0 ? '+' : '';
  return `${sign}${amountText(parsed, currency)}`;
}
